import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RiDashboardHorizontalLine } from 'react-icons/ri';
import { TbNotes } from "react-icons/tb";
import { MdOutlineBusinessCenter } from "react-icons/md";

// Simplified menuItems without subMenu
const menuItems = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/dashboard',
    },
    {
        id: 'quotation',
        title: 'Quotations',
        icon: <TbNotes className="me-2 fs-5" />,
        path: '/quotation/all',
    },
    {
        id: 'vendor',
        title: 'Business Details',
        icon: <MdOutlineBusinessCenter className="me-2 fs-5" />,
        path: '/vendor/details',
    },
    {
        id: 'profile',
        title: 'Profile',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/profile/view',
    },
    {
        id: 'password',
        title: 'password',
        icon: <RiDashboardHorizontalLine className="me-2 fs-5" />,
        path: '/password/change',
    },
];

function Sidebar({ isSidebarVisible }) {
    const location = useLocation();

    const [status, setStatus] = useState(localStorage.getItem('vendor_dashboard_status'));

    // Update status when local storage is updated
    useEffect(() => {
        const handleMerchantUpdate = () => {
            setStatus(localStorage.getItem('vendor_dashboard_status'));
        };

        window.addEventListener('vendorStatusUpdated', handleMerchantUpdate);

        return () => {
            window.removeEventListener('vendorStatusUpdated', handleMerchantUpdate);
        };
    }, []);

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <div className={`vertical-menu ${isSidebarVisible ? 'vertical-collpsed' : ''} mm-active`}>
            <div data-simplebar="init" className="h-100 mm-show">
                <div className="simplebar-wrapper" style={{ margin: 0 }}>
                    <div className="simplebar-content-wrapper" style={{ height: '100%', overflow: 'hidden' }}>
                        <div className="simplebar-content" style={{ padding: 0 }}>
                            <div id="sidebar-menu" className="mm-active">
                                <ul className="metismenu list-unstyled mm-show" id="side-menu">
                                    <li className="menu-title">Menu</li>
                                    {menuItems.slice(0, -2).map(({ id, title, icon, path }) => {
                                        const isDisabled = status !== "1" && (id === "quotation" || id === "vendor");

                                        return (
                                            <li key={id} className={isActive(path) ? 'mm-active' : ''}>
                                                <Link
                                                    to={isDisabled ? "#" : path}
                                                    className={`waves-effect custom-link ${isDisabled ? "disabled-link" : ""}`}
                                                    onClick={(e) => isDisabled && e.preventDefault()}
                                                    style={{
                                                        pointerEvents: isDisabled ? "none" : "auto",
                                                        opacity: isDisabled ? 0.5 : 1
                                                    }}
                                                >
                                                    {icon}
                                                    <span>{title}</span>
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
